import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const DirtyContext = createContext<
  [boolean, Dispatch<SetStateAction<boolean>>]
>(undefined!);

interface DirtyContextProviderProps {
  children: React.ReactNode;
}
export function DirtyContextProvider({ children }: DirtyContextProviderProps) {
  const [dirty, setDirty] = useState(false);

  return (
    <DirtyContext.Provider value={[dirty, setDirty]}>
      {children}
    </DirtyContext.Provider>
  );
}

export function useDirty(cleanOnExit = false) {
  const context = useContext(DirtyContext);

  const setDirty = useMemo(() => (context ? context[1] : undefined), [context]);

  useEffect(() => {
    if (cleanOnExit && setDirty) {
      return () => setDirty(false);
    }

    return undefined;
  }, [cleanOnExit, setDirty]);

  if (!context) {
    throw new Error("useDirty must be used within a DirtyContextProvider");
  }

  return context;
}
